import { createSelector } from 'reselect';

const list = state => state.forms.list;
const selectedGuid = state => state.forms.selectedGuid;

const selectedForm = createSelector(
  [list, selectedGuid],
  (forms, formGuid) => {
    const selected = !forms ? null : forms.find((form) => {
      return form.guid === formGuid;
    });
    return !selected ? null : selected;
  },
);

export default { selectedForm };
